import React from 'react';

const VERTICAL_LOGO = process.env.PUBLIC_URL + '/vertical-logo.svg';

// Keep in sync with TermsModal.js TERMS_SECTIONS when updating T&C content.
const TERMS_SECTIONS = [
  {
    title: '1. Agreement to Terms',
    body: `By accessing or using ClockEarnings ("the Service"), you agree to be bound by these Terms and Conditions ("Terms"). If you disagree with any part of these Terms, you may not access the Service. These Terms apply to all users, including organization administrators and employees.`,
  },
  {
    title: '2. Description of Service',
    body: `ClockEarnings provides time-tracking, payroll management, scheduling, and related workforce management tools to businesses and their employees. Features available to your organization depend on your selected subscription plan.`,
  },
  {
    title: '3. Account Registration & Responsibilities',
    body: `You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate, current, and complete information during registration and to update such information as necessary. You must notify us immediately of any unauthorized use of your account. ClockEarnings is not liable for any loss resulting from unauthorized account access.`,
  },
  {
    title: '4. Acceptable Use',
    body: `You agree to use the Service only for lawful purposes and in a way that does not infringe the rights of others. You must not: (a) use the Service to store or transmit unlawful content; (b) attempt to gain unauthorized access to any part of the Service; (c) interfere with or disrupt the integrity or performance of the Service; or (d) reverse-engineer any portion of the Service.`,
  },
  {
    title: '5. Privacy & Data',
    body: `Our Privacy Policy describes how we collect, use, and share information about you when you use the Service. By using the Service, you agree to our collection and use of information in accordance with our Privacy Policy. You retain ownership of all data you submit to the Service. We process employee data solely on your behalf and in accordance with your instructions as the data controller.`,
  },
  {
    title: '6. Billing & Payments',
    body: `Subscription fees are billed in advance on a monthly or annual basis depending on your selected billing cycle. All fees are non-refundable except as required by law. We reserve the right to change subscription fees with 30 days' advance notice. Failure to pay may result in suspension or termination of your account. Trial periods are provided at our sole discretion and may be discontinued at any time.`,
  },
  {
    title: '7. Intellectual Property',
    body: `The Service and its original content, features, and functionality are and will remain the exclusive property of Flurry Systems and its licensors. You may not copy, modify, distribute, sell, or lease any part of the Service without our prior written consent.`,
  },
  {
    title: '8. Limitation of Liability',
    body: `To the maximum extent permitted by law, Flurry Systems shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, arising out of or in connection with your use of the Service. Our total liability to you for any claim arising under these Terms shall not exceed the amount paid by you for the Service in the three months preceding the claim.`,
  },
  {
    title: '9. Termination',
    body: `We may suspend or terminate your access to the Service immediately, without prior notice, if you breach these Terms or if we determine that continued access poses a risk to the Service or other users. Upon termination, your right to use the Service ceases immediately. Provisions that by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, and limitations of liability.`,
  },
  {
    title: '10. Changes to Terms',
    body: `We reserve the right to modify these Terms at any time. When we make material changes, we will notify the account owner via email or an in-app notification. Continued use of the Service after changes become effective constitutes your acceptance of the revised Terms.`,
  },
  {
    title: '11. Governing Law',
    body: `These Terms shall be governed by the laws of the State of California, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the state and federal courts located in California.`,
  },
  {
    title: '12. Contact',
    body: `If you have any questions about these Terms, please contact us at support@clockearnings.com.`,
  },
];

export default function TermsPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: 'system-ui, -apple-system, sans-serif' }}>

      {/* Content */}
      <main style={{ maxWidth: 760, margin: '0 auto', padding: '60px 24px 100px' }}>

        <h1 style={{ fontSize: 36, fontWeight: 800, color: '#111827', marginBottom: 8 }}>
          Terms &amp; Conditions
        </h1>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 48 }}>Last updated: July 28, 2026</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
          {TERMS_SECTIONS.map(({ title, body }) => (
            <section key={title}>
              <h2 style={h2Style}>{title}</h2>
              <p style={bodyStyle}>{body}</p>
            </section>
          ))}
        </div>
      </main>

      <footer style={{
        borderTop: '1px solid #e5e7eb', padding: '24px 40px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: 16, background: 'white',
      }}>
        <img src={VERTICAL_LOGO} alt="ClockEarnings" style={{ height: 28 }} />
        <span style={{ fontSize: 13, color: '#9ca3af' }}>© {new Date().getFullYear()} ClockEarnings by Flurry Systems</span>
      </footer>
    </div>
  );
}

const h2Style = {
  fontSize: 20, fontWeight: 700, color: '#111827',
  marginBottom: 12, paddingBottom: 8,
  borderBottom: '2px solid #22c55e', display: 'inline-block',
};

const bodyStyle = {
  fontSize: 16, lineHeight: 1.75, color: '#374151', margin: 0,
};
